import { ExternalStyles, Text, TextColor, Theme, useStyles } from 'bold-ui'
import { FontWeightProperty } from 'csstype'
import React, { CSSProperties } from 'react'
import { CypressProps } from 'types/cypress'

export interface HLabelProps extends CypressProps {
  title: React.ReactNode
  children: React.ReactNode
  placeholder?: string
  color?: TextColor
  titleFontWeight?: FontWeightProperty
  style?: ExternalStyles
  placeholderStyle?: CSSProperties
}

function HLabelComponent(props: HLabelProps) {
  const { title, children, color, style, placeholder, dataTestId } = props
  const { css, classes } = useStyles(createStyles, props)

  return (
    <Text component='p' color={color} className={css(style)} placeholder={placeholder} data-testid={dataTestId}>
      <Text className={classes.title}>{title}</Text>
      <Text className={css(classes.content)}>{children}</Text>
    </Text>
  )
}

HLabelComponent.defaultProps = {
  placeholder: '—',
  titleFontWeight: 'bold',
}

const createStyles = (theme: Theme, { placeholder, titleFontWeight, placeholderStyle }: HLabelProps) => ({
  title: {
    fontWeight: titleFontWeight,
    marginRight: '0.375rem',
  } as CSSProperties,
  content: {
    '&:empty::before': {
      content: `"${placeholder}"`,
      ...placeholderStyle,
    },
  } as CSSProperties,
})

export const HLabel = React.memo(HLabelComponent)
